import ThankYouPage from '@features/thankYou/components/ThankYouPage'

const TestPage = () => {
  return <ThankYouPage />
}

export default TestPage
